<template>
  <div class="learnDefault conten column cen-start">
    <span class="ilbk learnImg text-center">
        <img src="../../assets/imgs/order.png" alt="">
    </span>
    <span @click="goHome" class="btn text-center ilbk ft16 white">立即选课学习吧</span>
  </div>
</template>

<script>
export default {
  name: 'oederDefault',
  data(){
      return {

      }
  },
  methods: {
      goHome(){
          this.$router.push({
              path: '/index'
          })
      }
  }
}
</script>
<style scoped lang="less">
.learnDefault{
    width: 100%;
    padding-top: 54/20rem;
    .learnImg{
        width: 319/20rem;
        height: 163/20rem;
    }
    .text{
        padding-top:38/20rem
    }
    .btn{
        margin-top:1.5rem;
        width:180/20rem;
        height:38/20rem;
        line-height:38/20rem;
        background:linear-gradient(90deg,rgba(253,123,49,1),rgba(240,130,67,1));
        box-shadow:0px 0px 7/20rem 3px rgba(253,123,49,0.43);
        border-radius:19/20rem;
    }
}
</style>
